exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.highlighted .form-control[data-v-ce1df420] {\n  border-color: orange;\n  font-weight: bold;\n}\n", ""]);

// exports
